import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PublishingTaskIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "PublishingTask",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M24.04 29.71H8c-1.89 0-3.43-1.54-3.43-3.43V5.71c0-1.89 1.54-3.43 3.43-3.43h5.71a1.14 1.14 0 1 1 0 2.28H8c-.63 0-1.14.51-1.14 1.14v20.57c0 .63.51 1.14 1.14 1.14h16.04c.63 0 1.14-.51 1.14-1.14V12.56a1.14 1.14 0 1 1 2.28 0v13.71c0 1.89-1.54 3.43-3.43 3.43Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M21.75 13.71c-.63 0-1.14-.51-1.14-1.14V1.14a1.14 1.14 0 1 1 2.28 0v11.43c0 .63-.51 1.14-1.14 1.14"
    }), /*#__PURE__*/_jsx("path", {
      d: "M26.32 6.86c-.29 0-.58-.11-.81-.33l-3.76-3.76-3.76 3.76c-.45.45-1.17.45-1.62 0a1.14 1.14 0 0 1 0-1.62L20.94.33a1.15 1.15 0 0 1 1.62 0l4.57 4.57a1.14 1.14 0 0 1-.81 1.95ZM21.71 24.61h-6.35a1.14 1.14 0 1 1 0-2.28h6.35a1.14 1.14 0 1 1 0 2.28M21.71 20.02h-6.35a1.14 1.14 0 1 1 0-2.28h6.35a1.14 1.14 0 1 1 0 2.28M17.14 15.44h-1.78a1.14 1.14 0 1 1 0-2.28h1.78a1.14 1.14 0 1 1 0 2.28"
    }), /*#__PURE__*/_jsx("rect", {
      width: "3.46",
      height: "3.46",
      x: "8.91",
      y: "17.14",
      rx: ".84",
      ry: ".84"
    }), /*#__PURE__*/_jsx("rect", {
      width: "3.46",
      height: "3.46",
      x: "8.91",
      y: "12.57",
      rx: ".84",
      ry: ".84"
    }), /*#__PURE__*/_jsx("rect", {
      width: "3.46",
      height: "3.46",
      x: "8.86",
      y: "21.74",
      rx: ".84",
      ry: ".84"
    })]
  }));
};